module.exports = __webpack_public_path__ + "img/vrbo.47f7ef3f.svg";